module.exports = __webpack_public_path__ + "img/google-play-badge.cfea2442.svg";